import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import { AppShell } from './AppShell';

/* ── Lazy-loaded screens (code-split per route) ── */
const PrimitivesDemo = lazy(() => import('./screens/PrimitivesDemo').then(m => ({ default: m.PrimitivesDemo })));
const SessionLog      = lazy(() => import('./screens/SessionLog').then(m => ({ default: m.SessionLog })));
const Partners        = lazy(() => import('./screens/Partners').then(m => ({ default: m.Partners })));
const Goals           = lazy(() => import('./screens/Goals').then(m => ({ default: m.Goals })));
const Dashboard       = lazy(() => import('./screens/Dashboard').then(m => ({ default: m.Dashboard })));
const Stats           = lazy(() => import('./screens/Stats').then(m => ({ default: m.Stats })));
const Techniques      = lazy(() => import('./screens/Techniques').then(m => ({ default: m.Techniques })));
const Sessions        = lazy(() => import('./screens/Sessions').then(m => ({ default: m.Sessions })));
const SessionDetail   = lazy(() => import('./screens/SessionDetail').then(m => ({ default: m.SessionDetail })));
const Settings        = lazy(() => import('./screens/Settings').then(m => ({ default: m.Settings })));
const Achievements    = lazy(() => import('./screens/Achievements').then(m => ({ default: m.Achievements })));
const Gameplans       = lazy(() => import('./screens/Gameplans').then(m => ({ default: m.Gameplans })));
const Instructionals  = lazy(() => import('./screens/Instructionals').then(m => ({ default: m.Instructionals })));
const ClozeReview     = lazy(() => import('./screens/ClozeReview').then(m => ({ default: m.ClozeReview })));
const Pricing         = lazy(() => import('./screens/Pricing').then(m => ({ default: m.Pricing })));
const Onboarding      = lazy(() => import('./screens/Onboarding').then(m => ({ default: m.Onboarding })));
const Pulse           = lazy(() => import('./screens/Pulse').then(m => ({ default: m.Pulse })));
const Health          = lazy(() => import('./screens/Health').then(m => ({ default: m.Health })));

function Loading() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '50vh', color: '#71717a', fontSize: 13,
    }}>
      Loading...
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<AppShell />}>
            <Route index element={<Dashboard />} />
            <Route path="session-log" element={<SessionLog />} />
            <Route path="session/:id" element={<SessionDetail />} />
            <Route path="sessions" element={<Sessions />} />
            <Route path="techniques" element={<Techniques />} />
            <Route path="partners" element={<Partners />} />
            <Route path="stats" element={<Stats />} />
            <Route path="goals" element={<Goals />} />
            <Route path="gameplans" element={<Gameplans />} />
            <Route path="instructionals" element={<Instructionals />} />
            <Route path="cloze" element={<ClozeReview />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="pulse" element={<Pulse />} />
            <Route path="health" element={<Health />} />
            <Route path="onboarding" element={<Onboarding />} />
            <Route path="settings" element={<Settings />} />
            <Route path="achievements" element={<Achievements />} />
            <Route path="primitives" element={<PrimitivesDemo />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

createRoot(document.getElementById('root')!).render(<App />);
